import request from 'utils/request'
import api from 'common/api/corp-tags'
import {stringify} from 'qs'

export async function getCorpTags(params) {
    return request(`${api.getCorpTags.url}?${stringify(params)}`)
}
